import { validateProcedure } from './procedureValidator';
import { concentrationCategory, failedOutcome, resolveFood } from './outcome';
import type { FoodInput, FoodTestOutcome, ProcedureState } from './types';

const colourForCategory = {
  negative: { colour: '#1677c8', name: 'blue', observation: 'The solution remains blue; no non-reducing sugar is detected after hydrolysis.' },
  trace: { colour: '#50a878', name: 'green', observation: 'A green suspension forms, indicating a trace amount of non-reducing sugar.' },
  'weak-positive': { colour: '#e6d347', name: 'yellow', observation: 'The mixture changes to yellow, indicating a low amount of non-reducing sugar.' },
  positive: { colour: '#e99132', name: 'orange', observation: 'The mixture becomes orange, indicating a moderate amount of non-reducing sugar.' },
  'strong-positive': { colour: '#a83b26', name: 'brick red', observation: 'A brick-red precipitate forms, indicating a high amount of non-reducing sugar.' },
};

/** Simulates acid hydrolysis, neutralisation, and the subsequent Benedict’s test. */
export function getHydrolysisOutcome(food: FoodInput, procedure: ProcedureState): FoodTestOutcome {
  const validation = validateProcedure('non-reducing-sugar', procedure);
  if (!validation.valid) return failedOutcome('non-reducing-sugar', validation.errors.join(' '));

  const sample = resolveFood(food);
  const category = concentrationCategory(sample.composition.nonReducingSugar);
  const reading = colourForCategory[category === 'failed' ? 'negative' : category];
  return {
    test: 'non-reducing-sugar',
    category,
    observation: reading.observation,
    colour: reading.colour,
    colourName: reading.name,
    precipitate: category === 'strong-positive',
    emulsion: false,
    reasoning: 'Dilute acid hydrolyses non-reducing disaccharides into reducing monosaccharides. Neutralisation is required before Benedict’s reagent is added.',
    warnings: validation.warnings,
  };
}